<template>
  <div class="block-guimo">
    <div class="wrap" v-if="type == 1">
      <div class="cn">
        <img src="/static/images/svolt/nanwang/cn-icon-bj.png" />
        <div class="number">{{ data.energyStoragePower.number }}/{{ data.energyStorageCapacity.number }}</div>
        <span class="txt">
          <div class="title">{{ data.energyStoragePower.title }}</div>
          <div class="unit">({{ data.energyStoragePower.unit }}/{{ data.energyStorageCapacity.unit }})</div>
        </span>
      </div>
      <div class="gf">
        <img src="/static/images/svolt/nanwang/gf-icon-bj.png" />
        <div class="number">{{ data.solarCapacity.number }}</div>
        <span class="txt">
          <div class="title">{{ data.solarCapacity.title }}</div>
          <div class="unit">({{ data.solarCapacity.unit }})</div>
        </span>
      </div>
      <div class="cd">
        <img src="/static/images/svolt/nanwang/cd-icon-bj.png" />
        <div class="number">{{ data.chargingPileCapacity.number }}</div>
        <span class="txt">
          <div class="title">{{ data.chargingPileCapacity.title }}</div>
          <div class="unit">({{ data.chargingPileCapacity.unit }})</div>
        </span>
      </div>
    </div>
    <div class="wrap" v-if="type == 2">
        <img class="chuneng-icon" src="/static/images/svolt/nanwang/chuneng-icon.png" />
        <img class="bk-img" src="/static/images/svolt/nanwang/bk.png" />
        <img class="fen-line" src="/static/images/svolt/nanwang/fen-line.png" />
        <div class="arp-number">{{ data.energyVolume }}</div>
        <div class="desc">储能总容量（kW/kWh）</div>
    </div>
    <div class="wrap" v-if="type == 3">
      <div class="lansi">
        <div class="tb">
          <img class="bj" src="/static/images/svolt/nanwang/cn-icon-bj-lansi.png" />
          <span class="txt">
            <div class="number">{{ data[1].data }}</div>
            <div class="title">{{ data[1].title }} {{ data[1].unit }}</div>
          </span>
        </div>
        <div class="tb">
          <img class="bj" src="/static/images/svolt/nanwang/gf-icon-bj-lansi.png" />
          <span class="txt left35">
            <div class="number indent10">{{ data[0].data }}</div>
            <div class="title">{{ data[0].title }} {{ data[0].unit }}</div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: [Object, Array]
    },
    height: {
      style: Number
    },
    type: {
      type: [Number, String],
      default: 1 //默认第一种
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
.block-guimo {
  width: 428px;
  height: 147px;
  display: inline-block;
  background: url('/static/images/svolt/nanwang/block-guimo-bj.png') no-repeat;
  background-size: 100%;
  margin-left: -6px;
  margin-top: 5px;
  .wrap {
    display: flex;
    width: 100%;
    height: 129px;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 15px;
    img {
      width: 125px;
      height: 79px;
      position: relative;
      z-index: 0;
    }
    .txt {
      width: 80px;
      display: inline-block;
      position: absolute;
      z-index: 2;
      left: 46px;
      top: -4px;
      text-align: center;
      .number {
        font-size: 18px;
        font-family: DINBold, DINAlternate;
        font-weight: bold;
        color: #19191a;
        background-clip: text;
        margin-bottom: 10px;
        position: absolute;
      }
      .title {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #7982a5;
        margin-bottom: 5px;
        margin-top: 34px;
      }
      .unit {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #7982a5;
      }
    }
    .cn {
      position: relative;
      .number {
        width: 125px;
        font-size: 18px;
        text-align: center;
        font-family: DINBold, DINAlternate;
        font-weight: bold;
        color: #19191a;
        background-clip: text;
        position: absolute;
        top: -10px;
      }
    }
    .gf {
      position: relative;
      .number {
        width: 125px;
        font-size: 18px;
        text-align: center;
        font-family: DINBold, DINAlternate;
        font-weight: bold;
        color: #19191a;
        background-clip: text;
        position: absolute;
        top: -10px;
      }
    }
    .cd {
      position: relative;
      .number {
        width: 125px;
        font-size: 18px;
        text-align: center;
        font-family: DINBold, DINAlternate;
        font-weight: bold;
        color: #19191a;
        background-clip: text;
        position: absolute;
        top: -10px;
      }
    }
    /* 阿尔派项目*/
      .chuneng-icon {
        width: 80px;
        height: 100px;
        position: absolute;
        top: 57px;
        left: 57px;
        z-index: 11;
      }
      .bk-img {
        position: absolute;
        bottom: 20px;
        width: 336px;
        height: 54px;
        z-index: 10;
      }
      .fen-line {
        position: absolute;
        bottom: 80px;
        left: 162px;
        width: 170px;
        height: 2px;
        z-index: 11;
      }
      .arp-number {
        font-family: DINBold, DINAlternate;
        font-size: 24px;
        font-weight: bold;
        color: #08265f;
        width: 170px;
        text-align: center;
        position: absolute;
        bottom: 110px;
        left: 162px;
        width: 170px;
        height: 2px;
        z-index: 11;
      }
      .desc {
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #5e688f;
        position: absolute;
        bottom: 70px;
        left: 162px;
        width: 170px;
        text-align: center;
        height: 2px;
        z-index: 11;
        width: 170px;
      }

    /* 蓝思项目 */
    .lansi {
      display: flex;
      justify-content: space-evenly;
      width: 100%;
      .bj {
        width: 190px;
        height: 79px;
      }
      .tb {
        position: relative;
        .left35{
          left:35px !important;
        }
        .txt {
          width: 144px;
          display: inline-block;
          position: absolute;
          z-index: 2;
          left: 45px;
          top: 12px;
          text-align: center;
          .number {
            font-size: 22px;
            font-family: DINBold, DINAlternate;
            font-weight: bold;
            color: #19191a;
            background-clip: text;
            margin-bottom: 10px;
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            text-align: left;
            text-indent: 5px;
          }
          .indent10{
            text-indent: 20px;
          }
          .title {
            font-size: 12px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: bold;
            color: #7982a5;
            margin-bottom: 5px;
            margin-top: 34px;
          }
          .unit {
            font-size: 12px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: bold;
            color: #7982a5;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/block-guimo.vue